export const CModalType = {
    MESSAGE: 'MESSAGE',
    RADIO: 'RADIO'
  } as const